import { parse as parseJS } from 'acorn';
import * as walk from 'acorn-walk';
import * as astravel from 'astravel';
import { measureLeadingComments } from './processScriptContent';
export const parseJsOptions = {
  allowAwaitOutsideFunction: true,
  allowReturnOutsideFunction: true,
  ecmaVersion: 'latest',
  sourceType: 'script'
};
/**
 * 接受一个 `estree.Identifier | estree.MemberExpression` 返回其对应的 变量 DataPath（例如 `["foo", "bar"]` 这种 DataPath 数组）
 */
export function getDataPathOfAST(node) {
  const remainders = [];
  while (node && node.type === 'MemberExpression') {
    // acorn 解析 foo.bar.baz 输出的结构是 (((foo).bar).baz) 这样的，所以要先收集下 bar 和 baz 这些 remainders
    remainders.unshift(node.property);
    // eslint-disable-next-line no-param-reassign
    node = node.object;
  }
  // 出现了奇怪的东西，比如 foo().bar 这里，点的左边是一个 CallExpression
  if (!node || node.type !== 'Identifier') return null;
  const ans = [node.name];
  // eslint-disable-next-line no-restricted-syntax
  for (const remainder of remainders) {
    if (remainder.type === 'Literal') ans.push(remainder.value);else if (remainder.type === 'Identifier') ans.push(remainder.name);else break; // 遇到无效 property，停止收集，例如 foo.bar[baz()].xxx 要在 foo.bar 就停下来
    // 备注：不用担心 foo.bar.baz().xxx 这种场景，因为这一整个会被解析成
    //
    // root = MemberExpression[                                 <= 你拿到的最外层 MemberExpression
    //    object    =   CallExpression(
    //                     callee = MemberExpression            <= 然而真正你关心的表达式在这里
    //                  )
    //    property  =  Identifier
    // ]
  }
  return ans;
}
/**
 * 输入一个源代码 AST 树，和字符位置，返回那个位置的 `estree.Identifier | estree.MemberExpression` （如果存在）
 *
 * 如果坐标落在 `foo.ba|r.baz` 这种位置，会向外搜索返回整个的 `foo.bar.baz` 的 `MemberExpression` ，而不是只返回个 `Identifier`
 *
 * 这个函数的返回值，一般是用作 `getDataPathOfAST()` 的输入值
 */
export function getMemberExpressionAt(root, start) {
  let ans = null;
  walk.findNodeAround(root, start, (typeInaccurateDoNotUse, node) => {
    if (node.type === 'Identifier' || node.type === 'MemberExpression') {
      ans = node;
      return false;
    }
    return true; // 终止搜索
  });
  return ans;
}
/**
 * 对 **花括号插值字符串** 里的 JS 表达式读取 AST，由于同时支持 `{foo: 123}` 和 `return 1+1` 这种写法，所以可能导致算出来的 start 存在 offset
 *
 * @param jsExpr js的表达式，可以是一个 {foo: 123} 这种对象
 */
export function parseJsExprSafe(jsExpr, opt = {}) {
  let offset = 0;
  let expr = jsExpr;
  // 由于表达式可能直接写的 {foo: 123} 这种对象，所以在 parse 时为了避免问题，要加个括号
  if (expr[measureLeadingComments(expr)] === '{') {
    expr = `(${jsExpr}\n)`;
    offset = 1;
  }
  let tempParseJsOptions = parseJsOptions;
  const comments = opt.comments ? [] : null;
  if (comments) tempParseJsOptions = {
    ...tempParseJsOptions,
    locations: true,
    onComment: comments
  };
  try {
    const ast = parseJS(expr, tempParseJsOptions);
    // 注入注释的信息
    if (comments !== null && comments !== void 0 && comments.length) astravel.attachComments(ast, comments);
    return {
      error: null,
      ast,
      offset
    };
  } catch (err) {
    if (err instanceof SyntaxError && typeof err.pos === 'number') {
      // acorn 会抛出 pos loc raisedAt
      return {
        error: err,
        raisedAt: err.pos + offset,
        offset
      };
    }
    throw err;
  }
}
//# sourceMappingURL=acorn.js.map
